export default "__VITE_ASSET__CDLQsLun__"